//
// MatrixEllipseParm.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/DataVisualization";
import "../data/PlotRole";

var MatrixEllipseParm = createModule("gtl::MatrixEllipseParm", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::RendererModel","gtl::DataRendererModel","gtl::DataVisualization"], EventDispatcher, [
    ,
    {
        semiMinor: 1,
        yOrigin: 1,
        semiMajor: 1,
        xOrigin: 1,
        slope: 1,
        clip: 2,
        cellNumber: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MatrixEllipseParm;
